<template>
  <div class="custom_col_xl col-lg-3 col-md-4 col-12 col-sm-5">
    <b-card no-body class=" mb-4" bg-variant="Default">
      <div class="d-flex justify-content-end pt-2">
      <div class="show-photo">
          <a href="#"
             title=""
             :id="'inspect_photo_eye' + photo_data.photo_id"
              @click="zoomImg('inspect_photo_eye', photo_data.inspect_photo, photo_data.photo_id)">
            <font-awesome-icon :icon="['fas', 'eye']"  />
          </a>
      </div>
      </div>
      <div class="users-list-photos__item-photo mb-3">
        <img :src="photo_data.inspect_photo"
             :id="'inspect_photo_main' + photo_data.photo_id"
              @click="zoomImg('inspect_photo_main', photo_data.inspect_photo, photo_data.photo_id)"
             alt="">
      </div>
      <div class="users-list-photos__bottom-side">
        <div class="d-flex justify-content-start mb-3">
          <div class="users-list-photos__user-avatar">
            <img class="user-avatar"
              :src="photo_data.user_avatar"
              :id="'avatar' + photo_data.avatar_id"
              @click="zoomImg('avatar', photo_data.user_avatar, photo_data.avatar_id)"
              alt="user avatar"
            />
        </div>
        <div class="users-list-photos__user-name ml-3 ">
          <div>
              <span v-if="current_user.admin_level > 10">
                  <a :href="'https://evo.skylove.su/users/user/edit?id=' + photo_data.user_id">{{ photo_data.user_name }}</a>
              </span>
              <span v-else>{{ photo_data.user_name}}</span>
              <span>({{ photo_data.user_years}})</span>
          </div>
          <div>{{ photo_data.user_city }}</div>

          <div class="users-list-photos__user-name_status d-flex mt-1">
            <div v-if="photo_data.user_vip" class="vip">
              <font-awesome-icon :icon="['fas', 'chess-queen']" />
            </div>
          </div>
        </div>
      </div>
        <div class="d-flex justify-content-between mb-2">
        <div>
          <b-button-group size="sm">
              <b-button variant="success"
                        title="Одобрить фото"
                        @click="setVerification(photo_data)">
                <font-awesome-icon :icon="['fas', 'user-check']" />
              </b-button>
              <b-button style="background-color: #E48800; border: none"
                        title="Отложить фото"
                        @click="setDeferred(photo_data)">
                <font-awesome-icon :icon="['fas', 'clock']" />
              </b-button>
          </b-button-group>
          <b-button-group size="sm">
              <template v-if="photo_data.main_photo === 1">
                  <b-button variant="primary"
                            title="Временно заблокировать основное фото"
                            @click="setTemporaryBlocked(photo_data)">
                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                  </b-button>
              </template>
              <template v-else>
                  <b-button style="background-color: #E48800; border: none"
                            title="Запретить фото для аватара"
                            @click="setForbiddenAvatar(photo_data)">
                    <font-awesome-icon :icon="['fas', 'user-times']" />
                  </b-button>
                  <b-button variant="danger"
                            title="Запретить фото для показа"
                            @click="setForbiddenShow(photo_data)">
                    <font-awesome-icon :icon="['fas', 'user-slash']" />
                  </b-button>
              </template>
          </b-button-group>
        </div>
        <div>
            <b-button-group size="sm">
                <b-button style="background-color: #E48800; border: none"
                          title="Забанить аккаунт"
                          @click="setBannedAcc(photo_data)">
                  <font-awesome-icon :icon="['fas', 'portrait']" />
                </b-button>
                <b-button variant="danger"
                          title="Забанить устройство"
                          @click="setBannedDev(photo_data)">
                  <font-awesome-icon :icon="['fas', 'mobile-alt']" />
                </b-button>
            </b-button-group>
        </div>
      </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import BigPicture from 'bigpicture';
import axios from '../../utils/axios';
import Swal from 'sweetalert2';

export default {
  props: {
    photo_data: {
      type: Object,
      default() {
        return {};
      },
    },
    current_user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      photosStatus: {
        deferred: -1,
        reset: 0,
        verification: 1,
        forbidden_avatar: 2,
        forbidden_show: 3,
        temporary_blocked: 4,
        banned_acc: 5,
        banned_dev: 6,
      },
      baseUrl: '',
      urlRequest: {
        // endpoints for checking photo
        set_verification_photo: '/api/v1/status-photos/verification-photo',
        set_deferred_photo: '/api/v1/status-photos/deferred-photo',
        set_forbidden_avatar: '/api/v1/status-photos/forbidden-avatar',
        set_forbidden_show: '/api/v1/status-photos/forbidden-show',
        set_temporary_blocked: '/api/v1/status-photos/temporary-blocked',
        banAcc: '/api/v1/status-photos/ban-acc',
        banDev: '/api/v1/status-photos/ban-dev',
      },
    };
  },
  methods: {
    zoomImg(name_id ,src_photo, photo_id) {
      BigPicture({
        el: document.getElementById(`${name_id}${photo_id}`),
        imgSrc: src_photo,
      });
    },
    /* установка статуса "проверено" */
    setVerification(photo) {
      const payload = {
        user_id: photo.user_id,
        photo_id: photo.photo_id,
        status: this.photosStatus.verification,
        main_photo: photo.main_photo,
      };
      return axios.post(this.baseUrl + this.urlRequest.set_verification_photo, payload)
        .then((response) => {
          //    todo
        })
        .catch((error) => {
          if (error.hasOwnProperty('response')) {
            // здесь норм сделать отабражение error
            console.log(error.response);
          } else {
            console.log(error);
          }
        });
    },
    /* установка статуса "отложено" */
    setDeferred(photo) {
      const payload = {
        user_id: photo.user_id,
        photo_id: photo.photo_id,
        status: this.photosStatus.deferred,
        main_photo: photo.main_photo,
      };
      return axios.post(this.baseUrl + this.urlRequest.set_deferred_photo, payload)
        .then((response) => {
          //    todo
        })
        .catch((error) => {
          if (error.hasOwnProperty('response')) {
            // здесь норм сделать отабражение error
            console.log(error.response);
          } else {
            console.log(error);
          }
        });
    },
    /* установка статуса "запрещено для аватара" */
    setForbiddenAvatar(photo) {
      const payload = {
        user_id: photo.user_id,
        photo_id: photo.photo_id,
        status: this.photosStatus.forbidden_avatar,
        main_photo: photo.main_photo,
      };
      return axios.post(this.baseUrl + this.urlRequest.set_forbidden_avatar, payload)
        .then((response) => {
          //    todo
        })
        .catch((error) => {
          if (error.hasOwnProperty('response')) {
            // здесь норм сделать отабражение error
            console.log(error.response);
          } else {
            console.log(error);
          }
        });
    },
    /* установка статуса "запрещено для показа" */
    setForbiddenShow(photo) {
      const payload = {
        user_id: photo.user_id,
        photo_id: photo.photo_id,
        status: this.photosStatus.forbidden_show,
        main_photo: photo.main_photo,
      };
      return axios.post(this.baseUrl + this.urlRequest.set_forbidden_show, payload)
        .then((response) => {
          //    todo
        })
        .catch((error) => {
          if (error.hasOwnProperty('response')) {
            // здесь норм сделать отабражение error
            console.log(error.response);
          } else {
            console.log(error);
          }
        });
    },
    /* установка статуса "временная блокировка" */
    setTemporaryBlocked(photo) {
      const payload = {
        user_id: photo.user_id,
        photo_id: photo.photo_id,
        status: this.photosStatus.temporary_blocked,
        main_photo: photo.main_photo,
      };
      return axios.post(this.baseUrl + this.urlRequest.set_temporary_blocked, payload)
        .then((response) => {
          //    todo
        })
        .catch((error) => {
          if (error.hasOwnProperty('response')) {
            // здесь норм сделать отабражение error
            console.log(error.response);
          } else {
            console.log(error);
          }
        });
    },
    /* бан аккаунта */
    setBannedAcc(photo) {
      const payload = {
        user_id: photo.user_id,
        photo_id: photo.photo_id,
        status: this.photosStatus.banned_acc,
        main_photo: photo.main_photo,
      };
      Swal.fire({
        title: 'Забанить аккаунт?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusCancel: true,
        confirmButtonText: 'Забанить аккаунт',
        cancelButtonText: 'Отмена',
        confirmButtonColor: '#C82333',
      }).then((result) => {
    	if (result.value) {
          return axios.post(this.baseUrl + this.urlRequest.banAcc, payload)
            .then((response) => {
              //    todo
              // this.$parent.photo_album =
            })
            .catch((error) => {
              if (error.hasOwnProperty('response')) {
                // здесь норм сделать отабражение error
                console.log(error.response);
              } else {
                console.log(error);
              }
            });
    	}
      });
    },
    /* бан устройства */
    setBannedDev(photo) {
      const payload = {
        user_id: photo.user_id,
        photo_id: photo.photo_id,
        status: this.photosStatus.banned_dev,
        main_photo: photo.main_photo,
      };

      Swal.fire({
        title: 'Забанить устройство?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusCancel: true,
        confirmButtonText: 'Забанить устройство',
        cancelButtonText: 'Отмена',
        confirmButtonColor: '#C82333',
      }).then((result) => {
    	if (result.value) {
    	  return axios.post(this.baseUrl + this.urlRequest.banDev, payload)
            .then((response) => {
              //    todo
            })
            .catch((error) => {
              if (error.hasOwnProperty('response')) {
                // здесь норм сделать отабражение error
                console.log(error.response);
              } else {
                console.log(error);
              }
            });
    	     }
      });
    },
  },
};
</script>

<style scoped>
.users-list-photos__item-photo {
    /*max-height: 20.18rem;*/
    width: 100%;
    overflow: hidden;
    border-radius: 2%;
}

.users-list-photos__user-avatar{
    width: 4rem;
    height: 4rem;
    border-radius: 10%;
    overflow: hidden;
}

.users-list-photos__user-avatar img{
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.users-list-photos__item-photo img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.users-list-photos__user-name{
  line-height: 1.3;
  font-size: .8rem;
}

.users-list-photos__user-name div:first-child span:first-child{
    font-weight: 700;
    color: #667fa0;

}
.user_name_link{
  text-decoration: none;
  color: #667fa0;
}

a:hover {
  color: #2a3542;
}

a {
  color: #667fa0;
}

.card {
  border: none;
}

@media (min-width: 1200px) {
  .custom_col_xl {
    -ms-flex: 0 0 12.666667%;
    flex: 0 0 12.666667%;
    max-width: 250px;
    min-width: 250px;
  }
}

@media (min-width: 1920px) {
  .users-list-photos__bottom-side{
    opacity: 0.3;
    transition: all .25s ease-out;
  }

  .users-list-photos__bottom-side:hover{
    opacity: unset;
  }

}

.user-avatar:hover {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/users/StatusPhotosItemComponent.vue